import facebookIcon from "./facebook.svg";
import twitterIcon from "./twitter.svg";
import linkedInIcon from "./linkedin.svg";
import instgramIcon from "./instagram.svg";
import addressIcon from "./address.svg";
import emailIcon from "./email.svg";
import phoneIcon from "./phone.svg";
import playIcon from "./playIcon.svg";
import affordable from "./affordable.svg";
import problem from "./problem.svg";
import quality from "./quality.svg";
import quick from "./quick.svg";
import tailored from "./tailored.svg";
import universal from "./universal.svg";
import filterIcon from "./filter.svg";
import listArrow from "./list-arrow.svg";
import scroll from "./scroll.svg";
import closeIcon from "./close.svg";
import nextArrow from "./nextArrow.svg";
import prevArrow from "./prevArrow.svg";

const icons = {
  facebookIcon,
  twitterIcon,
  linkedInIcon,
  instgramIcon,
  addressIcon,
  emailIcon,
  phoneIcon,
  playIcon,
  affordable,
  problem,
  quality,
  quick,
  tailored,
  universal,
  filterIcon,
  closeIcon,
  listArrow,
  scroll,
  nextArrow,
  prevArrow,
};

export default icons;
